module.exports = __webpack_public_path__ + "static/media/landing_shipping.2cd00bab.svg";